import {
  GET_ENV_VARIABLES_REQUEST,
  GET_ENV_VARIABLES_SUCCESS,
  GET_ENV_VARIABLES_ERROR
} from "../actions/env_variables";

const defaultState = {
  isFetching: false,
  fetchedAt: null,
  error: null,
  data: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ENV_VARIABLES_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_ENV_VARIABLES_SUCCESS: {
      const { data } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data
      };
    }
    case GET_ENV_VARIABLES_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }
    default: return state;
  }
};
